<template>
  <div class="flex flex-wrap items-center gap-x-4 gap-y-1">
    <span v-for="f in shown" :key="f.key" class="flex items-center">
      <i class="fa-solid fa-circle-info text-gray-400 mr-1.5 text-xs"></i>
      <span class="text-gray-400 mr-1">{{ f.label }}:</span>
      <span class="font-medium">{{ display(f) }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "CustomFieldsDisplay",
  props: {
    job: { type: Object, required: true },
    fields: { type: Array, default: () => [] },
  },
  computed: {
    shown() {
      return this.fields.filter((f) => {
        const v = this.job[f.key];
        if (f.type === "checkbox") return v === true;
        return v !== undefined && v !== null && v !== "";
      });
    },
  },
  methods: {
    display(f) {
      if (f.type === "checkbox") return "Yes";
      return this.job[f.key];
    },
  },
};
</script>
